
import { defineComponent } from 'vue'
import SkeletonBox from './SkeletonBox.vue'
import SkeletonIcon from './SkeletonIcon.vue'
import SkeletonText from './SkeletonText.vue'
export default defineComponent({
  name: 'SkeletonDesafioForm',
  components: { SkeletonText, SkeletonBox, SkeletonIcon }
})
